<template>
  <div class="tab-content" :style="{height: slideHeight}">
    <transition :name="aniName">
      <!-- <keep-alive> -->
        <component :is="view" @slideTo="slideToFn" @slideNext="slideNextFn" @slidePrev="slidePrevFn"></component>
      <!-- </keep-alive> -->
    </transition>
  </div>
</template>

<script>
import Loading from './Loading'

export default {
  name: 'Tab',
  props: {
    slideGroup: {
      type: Array
    },
    slideHeight: {
      type: String,
      default: '100%'
    }
  },
  data () {
    return {
      aniName: 'fade-up',
      activeIndex: -1
    }
  },
  computed: {
    view () {
      let item = this.slideGroup[this.activeIndex]
      if (typeof (item) === 'undefined') return ''
      return () => ({
        component: import('../main/' + item),
        loading: Loading,
        delay: 200
      })
    }
  },
  methods: {
    slideToFn (i) {
      if (this.activeIndex === i) return
      this.aniName = this.activeIndex > i ? 'fade-down' : 'fade-up'
      this.activeIndex = i
    },
    slideNextFn () {
      let i = this.activeIndex + 1
      if (i > this.slideGroup.length - 1) return
      this.slideToFn(i)
    },
    slidePrevFn () {
      let i = this.activeIndex - 1
      if (i < 0) return
      this.slideToFn(i)
    }
  }
}
</script>

<style scoped>
.tab-content {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.fade-up-enter-active,
.fade-up-leave-active,
.fade-down-enter-active,
.fade-down-leave-active {
  transition: opacity .3s ease-in-out, transform .3s ease-in-out;
}
.fade-up-enter,
.fade-down-leave-to {
  opacity: 0;
  /* transform: translate3d(0, 20%, 0); */
}
.fade-up-leave-to,
.fade-down-enter {
  opacity: 0;
  /* transform: translate3d(0, -20%, 0); */
}
</style>
